import { FiSun, FiMoon } from 'react-icons/fi';
import { FaComputer } from 'react-icons/fa6'

const Icons = {
    Moon: FiMoon,
    Sun: FiSun,
    Computer: FaComputer,
}

export default Icons;